// Root Layout 的所有 provider 都在这里处理
'use client';

import DeferredRootHandlers from '@/components/deferred-root-handlers';
import FacebookOAuthHashHandler from '@/components/facebook-oauth-hash-handler';
import FirebaseLoginRedirectHandler from '@/components/firebase-login-redirect-handler';
import GlobalTrackerSync from '@/components/global-tracker-sync';
import { LoginModalHost } from '@/components/login-modal';
import PayPalReturnConfirmHandler from '@/components/paypal-return-confirm-handler';
import ReaderExitLoginPrompt from '@/components/reader-exit-login-prompt';
import I18NRootLayout from '@/i18n/i18n-root-layout';
import AuthSessionBootstrap from '@/providers/root/auth-session-bootstrap';
import PayPalSdkPreload from '@/providers/root/paypal-sdk-preload';

import TanstackQueryProvider from './tanstack-query';
import { ToastProvider } from './toast';

interface IProps {
    children: React.ReactNode;
}

export default function RootProvider({ children }: Readonly<IProps>) {
    return (
        <I18NRootLayout>
            <ToastProvider>
                <TanstackQueryProvider>
                    <DeferredRootHandlers />
                    <FirebaseLoginRedirectHandler />
                    <FacebookOAuthHashHandler />
                    <PayPalReturnConfirmHandler />
                    <ReaderExitLoginPrompt />
                    <AuthSessionBootstrap />
                    <PayPalSdkPreload />
                    <GlobalTrackerSync />
                    <LoginModalHost />
                    {children}
                </TanstackQueryProvider>
            </ToastProvider>
        </I18NRootLayout>
    );
}
